<template>
	<div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
		<el-page-header @back="goBack" :content="id ? '编辑快递' : '添加快递'"></el-page-header>
		<el-form label-position="right" :rules="rules" ref="ruleForm" :model="item" label-width="auto">
			<!--            有id时候 静态页面数据-->
			<el-form-item label="物流公司名称" prop="express_name">
				<el-input v-model="item.express_name" placeholder="请输入物流公司名称"></el-input>
			</el-form-item>
			<el-form-item label="物流公司代码" prop="express_code">
				<el-input v-model="item.express_code" placeholder="请输入物流公司代码"></el-input>
			</el-form-item>
			<el-form-item label="排序">
				<el-input v-model="item.orders" placeholder="请输入排序"></el-input>
			</el-form-item>

			<el-form-item>
				<el-button size="big" type="primary" @click="checkSubmit">保存</el-button>
			</el-form-item>
			<el-form-item>
				<el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
					<span>您确认保存嘛</span>
					<span slot="footer" class="dialog-footer">
						<el-button @click="dialogVisible = false">取 消</el-button>
						<el-button type="primary" @click="submit">确 定</el-button>
					</span>
				</el-dialog>
			</el-form-item>
		</el-form>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				item: {},
				isLoad: false,
				id: this.$route.query.id,
				dialogVisible: false,
				rules:{
					express_name: [
						{required: true, message: '物流公司名称不能为空', trigger: 'blur'},
					],
					express_code: [
						{required: true, message: '物流公司代码不能为空', trigger: 'blur'},
					],
				}
			}
		},
		created() {
			if(this.id){
				this.loadData()
			}
		},
		methods: {
			loadData: function() {
				if (this.isLoad)
					return
				this.isLoad = !this.isLoad
				this.axios.get('/admin/setting.logistics/detail',{
						params:{
							id:this.id
						}
					}).then(res => {
					this.isLoad = !this.isLoad
					this.item = res.data.detail
				}).catch(() => {
					this.isLoad = !this.isLoad
				})
			},
			// 后退一步
			goBack() {
				this.$router.back(-1)
			},
			checkSubmit(){
			    this.$refs['ruleForm'].validate((valid) => {
			        if (valid) {
			            this.dialogVisible = true
			        } else {
			            this.$message.warning("请检查表单信息是否正确");
			            return false;
			        }
			    });
			},
			// 提交
			submit() {
				if (this.isLoad) {
					return
				}
				this.isLoad = !this.isLoad
				let url = ''
				if (this.id) {
					url = '/admin/setting.logistics/edit'
					this.item.id = this.id
				} else {
					url = '/admin/setting.logistics/add'
				}
				this.axios.post(url, this.item)
					.then(() => {
						this.isLoad = !this.isLoad
						this.$message.success({
							message: '保存成功'
						});
						this.goBack()
					})
					.catch(() => {
						this.isLoad = !this.isLoad
					})
			},
		}
	}
</script>
<style scoped>
</style>
